export { default } from "./DispensaryCard";
